import { ActionIcon, Alert, Button, Code, CopyButton, Group, Modal, Stack, Text, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy, IconInfoCircle } from '@tabler/icons-react';

/** Shows a one-time secret (temporary password) with a copy button. It is never shown again. */
export function SecretRevealModal({
  opened,
  onClose,
  title,
  email,
  secret,
}: {
  opened: boolean;
  onClose: () => void;
  title: string;
  email: string;
  secret: string | null;
}) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} closeOnClickOutside={false}>
      <Stack gap="md">
        <Text fz="sm">
          Share this temporary password with <b>{email}</b> through a secure channel. They must choose their own password when they sign
          in.
        </Text>
        <Group gap="xs" wrap="nowrap">
          <Code fz="lg" p="sm" style={{ flex: 1, letterSpacing: 1 }}>
            {secret}
          </Code>
          <CopyButton value={secret ?? ''} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copied' : 'Copy'}>
                <ActionIcon size="lg" variant="light" color={copied ? 'teal' : 'brand'} onClick={copy} aria-label="Copy password">
                  {copied ? <IconCheck size={18} /> : <IconCopy size={18} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        </Group>
        <Alert variant="light" color="yellow" icon={<IconInfoCircle size={18} />}>
          This password is shown only once and is not stored anywhere readable.
        </Alert>
        <Button onClick={onClose}>Done</Button>
      </Stack>
    </Modal>
  );
}
